import { useState, useEffect } from 'react';

export const useMatchMedia = (mediaToMatch, innerWidth) => {
  const [mQuery, setMQuery] = useState(() => ({
    matches: typeof window !== 'undefined' ? window.innerWidth <= innerWidth : true,
    media: mediaToMatch,
  }));

  useEffect(() => {
    const mediaQuery = window.matchMedia(mediaToMatch);
    setMQuery({ matches: mediaQuery.matches, media: mediaQuery.media });

    const listener = ({ matches, media }) => {
      setMQuery({ matches, media });
    };

    mediaQuery.addEventListener('change', listener);
    return () => mediaQuery.removeEventListener('change', listener);
  }, []);

  return mQuery;
};